import 'bootstrap-datepicker/dist/css/bootstrap-datepicker.min.css';
import 'select2/dist/css/select2.min.css';
import 'select2-bootstrap-theme/dist/select2-bootstrap.min.css';
import './scss/atmos.scss';

import 'pace';
import 'jquery';
import 'popper.js';
import 'bootstrap';
import 'bootstrap-datepicker/dist/js/bootstrap-datepicker.min';
import 'jquery.scrollbar';
import 'bootstrap-notify';
import 'select2/dist/js/select2.min';
import '../../vendor/yiisoft/yii2/assets/yii';
import './common/atmos';
import './common/app';
import './common/modal-events'
